import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Receive = Loadable({
    loader: () => import('./Receive'),
    render(loaded, props) {
      const Component = connect((state) => ({
        mobileTransferReceiveState: state.mobileTransferReceiveState,
        siteConfig: state.siteConfig
      }), {
        init,
        submit,
        languageChange
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/receive`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Receive {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
